export interface TooltipItem {
  bulletStyle?: string;
  color?: string;
  subsections?: TooltipItem[][];
  // Intended for TooltipItemType=Data theme for text highlight
  theme?: string;
  text: string;
  type: TooltipItemType;
}

export enum TooltipItemType {
  Data = `data`,
  Strong = `strong`,
  Text = `text`,
}

export enum TooltipBulletStyle {
  Dash = `dash`,
  Solid = `solid`,
}
